@if (moduleSetup) {
  @if (mountRouter) {
    <router-outlet></router-outlet>
  }
}
<app-app-spinner-wrapper></app-app-spinner-wrapper>
@if (!hideLatency) {
  <app-latency-display></app-latency-display>
}
